import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiCalendar } from 'react-icons/fi';

const FloatingCTA = () => {
  const location = useLocation();
  
  // Don't show on booking page
  if (location.pathname === '/booking') return null;

  return (
    <motion.div 
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1 }}
      className="fixed bottom-6 right-6 z-40"
    >
      <Link 
        to="/booking"
        className="flex items-center gap-2 bg-secondary text-primary px-6 py-3 rounded-full font-medium shadow-[0_0_20px_rgba(212,163,115,0.3)] hover:scale-105 hover:bg-light transition-all duration-300"
      >
        <SafeIcon icon={FiCalendar} />
        <span className="hidden md:inline">This is a demo project</span>
        <span className="md:hidden">Book</span>
      </Link>
    </motion.div>
  );
};

export default FloatingCTA;